// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3rsIC","title":"AfterBackImages_title__3qlgN","images":"AfterBackImages_images__3gM-y"};